import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    path: 'account',
    loadChildren: () =>
      import('../../account/account.module').then(m => m.AccountModule),
  },
  {
    path: 'administration',
    loadChildren: () =>
      import('../../administration/administration.module').then(
        m => m.AdministrationModule,
      ),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('../../dashboard/dashboard.module').then(m => m.DashboardModule),
  },
  {
    path: 'debrief',
    loadChildren: () =>
      import('../../report-access/report-access.module').then(
        m => m.ReportAccessModule,
      ),
  },
  {
    path: 'downloads',
    loadChildren: () =>
      import('../../downloads/downloads.module').then(m => m.DownloadsModule),
  },
  {
    path: 'help',
    loadChildren: () =>
      import('../../help/help.module').then(m => m.HelpModule),
  },
  {
    path: 'institutions',
    loadChildren: () =>
      import('../../institution/institution.module').then(
        m => m.InstitutionModule,
      ),
  },
  {
    path: 'reporting-codes',
    loadChildren: () =>
      import('../../reporting-codes/reporting-codes.module').then(
        m => m.ReportingCodesModule,
      ),
  },
  {
    path: 'scenario-packages',
    loadChildren: () =>
      import('../../scenario-package/scenario-package.module').then(
        m => m.ScenarioPackageModule,
      ),
  },
  {
    path: 'scenarios',
    loadChildren: () =>
      import('../../scenario/scenario.module').then(m => m.ScenarioModule),
  },
  {
    path: 'users',
    loadChildren: () =>
      import('../../user/user.module').then(m => m.UserModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { resolveNavigationPromiseOnError: true }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
